import React, { Component } from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import $ from 'jquery';
import { Modal, ModalBody } from 'reactstrap';
import { ToastContainer } from 'react-toastify';
import toast from '../toast';
import { css } from 'glamor';
import crypto from 'crypto';

//  ----------------   Custom components
import SidebarMenu from './SidebarMenu/SidebarMenu';
import Dashboard from './Dashboard/DashboardDefault/DashboardDefault';
import Analytics from './ConnectionsAnalytics/analytics';
import ScheduleList from './Dashboard/Video/ScheduleList/ScheduleList';
import Account from './Account/Account';
import SocialMedia from './SocialMedia/SocialMedia';
import SocialPlatform from '../SocialPlatform/SocialPage.js';
import Footer from '../Footer/Footer';
import InstagramPage from '../Instagram';
import './Dashboard/Video/Video.css';
import './DashboardPage.css';
import MediaComment from './Dashboard/mediaComment/MediaComment';

class DashboardPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageNumber: 1,
      modal: false,
      isEmailVerified: localStorage.getItem('isEmailVerified') === 'true',
      channels: [],
      fbDetails: []
    };

    this.saveMatchForSidebarMenu = this.saveMatchForSidebarMenu.bind(this);
    this.resendMail = this.resendMail.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.notifySuccess = this.notifySuccess.bind(this);
    this.notifyError = this.notifyError.bind(this);
  }

  resendMail(event) {
    event.preventDefault();
    let nonce = new Date().getTime();
    let authtoken = localStorage.getItem('authToken');
    let apiKey = localStorage.getItem('apiKey');
    let signature = crypto.createHmac('sha256', authtoken).update(nonce.toString()).digest('hex');

    localStorage.setItem('time', nonce);
    localStorage.setItem('signature', signature);

    const data = { nonce, apiKey, signature };
    const url = '/api/v1/send/verification/mail'; // send verification email api url

    // Api call to resend the verification mail
    $.ajax({
      url: url,
      type: 'POST',
      success: function (res) {

        const msg = res.message;
        this.notifySuccess(msg); // notify user to check their mail
      }.bind(this),
      error: function (err) {
        this.notifyError(err.responseJSON.message);
      }.bind(this)
    });
  }

  notifySuccess(msg) {
    toast.success(msg);
  }

  notifyError(msg) {
    toast.error(msg);
  }

  toggleModal(e) {
    this.setState({
      modal: !this.state.modal
    });
  }

  fbstatsDetail = (statsDetails) => {
    this.setState({
      fbDetails: statsDetails
    })
  }

  isSocialLogin = () => {
    if (window.location.pathname == "/social/media/login") {
      return true;
    }
  }

  ytStats = (ytVideoStats) => {
    this.setState({
      ytImpression: ytVideoStats
    })
  }
  isAuthenticated() {
    const token = localStorage.getItem('authToken');
    if (token) {
      return true;
    }
    //this true for user go to dashboard without login
    return true;
    // return false;
  }

  saveMatchForSidebarMenu(match) {
    this.setState({ sidebarMatchProp: match });
  }

  render() {
    const currentLocationPath = this.props.location.pathname;
    const isAuthenticated = this.isAuthenticated();
    const socialUrl = this.isSocialLogin();
    // redirecting to /dashboard/main and saving current state to next path by pushing it to history object
    if (isAuthenticated && (currentLocationPath === '/' || currentLocationPath === '/dashboard')) {
      this.props.history.push('/dashboard/main');
    }
    if (isAuthenticated) {
      return (
        <div className="DashboardPage d-flex flex-column flex-grow">
          <div className="DasboardPageMain d-flex flex-grow">
            {/* sidebar with slide-in effect from left on toggle */}
            <SidebarMenu currentLocationPath={currentLocationPath} channels={this.state.channels} matchProp={this.state.sidebarMatchProp} />
            <div className="DashboardPage__overlay" />

            <main className="DashboardPage__Content d-flex flex-grow">
              <Switch>
                {/* swapping DashboardPage's Child Components based on current url set by <Router/> */}
                <Route exact path="/dashboard/main" render={(props) => (
                    
                  <Dashboard {...props}
                    toggleModal={this.toggleModal}
                    saveMatchForSidebarMenu={this.saveMatchForSidebarMenu}
                    notifySuccess={this.notifySuccess}
                    notifyError={this.notifyError} />
                )
                } />
                <Route exact path="/dashboard/account" render={(props) => (
                  <Account {...props}
                    saveMatchForSidebarMenu={this.saveMatchForSidebarMenu}
                    notifySuccess={this.notifySuccess}
                    notifyError={this.notifyError} />
                )} />
                <Route exact path="/dashboard/socialMedia" render={(props) => (
                  <SocialMedia {...props}
                    saveMatchForSidebarMenu={this.saveMatchForSidebarMenu}
                    notifySuccess={this.notifySuccess}
                    notifyError={this.notifyError} />
                )} />


                <Route exact path="/dashboard/social/platform" render={(props) => (
                  <SocialPlatform {...props}
                    saveMatchForSidebarMenu={this.saveMatchForSidebarMenu}
                    notifySuccess={this.notifySuccess}
                    notifyError={this.notifyError} />
                )} />

                <Route exact path="/dashboard/comments" render={(props) => (
                  <MediaComment {...props}
                    saveMatchForSidebarMenu={this.saveMatchForSidebarMenu}
                    notifySuccess={this.notifySuccess}
                    notifyError={this.notifyError} />
                )} />

                <Route exact path="/dashboard/schedule/broadcast" render={(props) => (
                  <ScheduleList {...props}
                    saveMatchForSidebarMenu={this.saveMatchForSidebarMenu}
                    notifySuccess={this.notifySuccess}
                    notifyError={this.notifyError}
                    fbStats={this.state.fbDetails}
                    ytReactions={this.state.ytImpression}
                  />
                )} />

                <Route exact path="/dashboard/social/statistics" render={(props) => (
                  <Analytics {...props}
                    saveMatchForSidebarMenu={this.saveMatchForSidebarMenu}
                    notifySuccess={this.notifySuccess}
                    notifyError={this.notifyError}
                  />
                )} />

                <Route exact path="/dashboard/instagram/rtmp" render={(props) => (
                  <InstagramPage {...props}
                    // saveMatchForSidebarMenu={this.saveMatchForSidebarMenu}
                    notifySuccess={this.notifySuccess}
                    notifyError={this.notifyError}
                  />
                )} />

              </Switch>
            </main>
          </div>
          <Footer />

          {/* React toastify for toast notifications */}
          <ToastContainer
            className={{ textAlign: 'center' }}
            progressClassName={css({ background: '#00B39F' })} />
        </div>
      );
    }
    else {
      return <Redirect to={'/'} />;
    }
  }
}

export default withRouter(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/DashboardPage/DashboardPage.js